























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { CHAT_TYPE } from "@/resources/constants/chat";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "pinned-messages-component",
})
export default class PinnedMessagesComponent extends mixins(
  UserValidator,
  NotificationEvent,
  Plans
) {
  @Prop() active: boolean;
  @Prop(Number) roomId: number | null;
  pinnedMessages = [];
  loading = false;
  PLAN = PLAN;
  get openModal(): boolean {
    return this.active;
  }
  set openModal(e) {
    this.$emit("close-modal", e);
  }
  @Watch("active")
  getPinnedMessages(): void {
    if (!this.activeOptionPlan(PLAN.PIN_MESSAGES)) return;
    if (this.active) {
      this.loading = true;
      const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
      const space = this.$store.getters["SpaceStore/getSpace"];
      const chatType = this.$store.getters["ChatStore/getChatType"];
      this.$store.dispatch("ChatStore/getPinnedMessageAction", {
        id: spaceUser.id,
        spaceId: space.id,
        roomId: chatType === CHAT_TYPE.ROOM ? this.roomId : null,
        callback: (data) => {
          this.loading = false;
          if (!data.status) this.pinnedMessages = data;
        },
      });
    } else {
      this.pinnedMessages = [];
    }
  }
  momentDate(date: string): string {
    return moment(date).format("MMMM DD YYYY, HH:mm");
  }
  convertUrlToLink(text: string): string {
    /* if (this.isHtml(text)) return text.toString();*/
    // URLs starting with http://, https://, or ftp://
    const replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    let replacedText = text.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '<a href="http://$2" target="_blank">$2</a>'
    );

    // Change email addresses to mailto:: links.
    const replacePattern3 =
      /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );
    const div = document.createElement("p");

    replacedText = replacedText.replace("/*?/", "");
    replacedText = replacedText.replace("/*>/", "");
    div.innerHTML = replacedText;
    return replacedText;
  }
  isHtml(text: string): boolean {
    const regex = /<[^>]*>/;
    return regex.test(text);
  }
  deletePinnedMessage(id: number): void {
    this.$store.dispatch("ChatStore/deletePinnedMessageAction", {
      id,
      callback: () => {
        const index = this.pinnedMessages.findIndex((a) => a.id === id);
        this.pinnedMessages.splice(index, 1);
        const tooltip = document.getElementsByClassName("vs-tooltip left")[0];
        tooltip.remove();
        const pinnedMessagesLength =
          this.$store.getters["ChatStore/getPinnedMessagesLength"];
        this.$store.dispatch(
          "ChatStore/setPinnedMessagesLengthAction",
          parseInt(pinnedMessagesLength) - 1
        );
        this.onDefault(
          "",
          this.$i18n.t("notifications.descriptions.deletePinnedMessage")
        );
      },
    });
  }
}
